import { useContext, createContext, useState, useMemo } from 'react';

type ConfirmParams = {
  onConfirm?: any;
  onCancel?: any;
  confirmText?: string;
  cancelText?: string;
  message: string | React.ReactNode;
  title?: string;
};

type ConfirmContextState = [React.Dispatch<React.SetStateAction<ConfirmParams | null>>, ConfirmParams | null] | null;

const confirmContext = createContext<ConfirmContextState>(null);

type ConfirmProviderProps = {
  children: React.ReactNode;
};

const useConfirm = () => {
  const context = useContext(confirmContext);

  if (!context) {
    throw new Error('useConfirm must be used within a ConfirmProvider');
  }

  return context;
};

const ConfirmProvider = (props: ConfirmProviderProps) => {
  const [showConfirm, setShowConfirm] = useState<ConfirmParams | null>(null);

  const value = useMemo<[React.Dispatch<React.SetStateAction<ConfirmParams | null>>, ConfirmParams | null]>(
    () => [setShowConfirm, showConfirm],
    [showConfirm]
  );

  return <confirmContext.Provider value={value} {...props} />;
};

export { ConfirmProvider, useConfirm };
